import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API, withCredentials: true });

let refreshing = null;
api.interceptors.response.use((r) => r, async (error) => {
  const cfg = error.config;
  const url = cfg?.url || "";
  if (error.response?.status !== 401 || cfg._retried || url.startsWith("/auth/")) return Promise.reject(error);
  cfg._retried = true;
  try {
    refreshing = refreshing || api.post("/auth/refresh").finally(() => { refreshing = null; });
    await refreshing;
    return api(cfg);
  } catch {
    window.dispatchEvent(new Event("auth:expired"));
    return Promise.reject(error);
  }
});

export const photoUrl = (path) => (path ? `${API}/files/${path}` : "");

export const SIZES = [36, 37, 38, 39, 40, 41, 42, 43, 44, 45];

export const koliPairs = (ratios) => Object.values(ratios || {}).reduce((a, b) => a + b, 0);
export const koliText = (ratios) => Object.entries(ratios || {}).map(([s, r]) => `${s}×${r}`).join(" · ");

// sizeQty: { size: qty } -> how many full boxes of this type fit
export const koliCount = (sizeQty, ratios) => {
  const entries = Object.entries(ratios || {});
  if (!entries.length) return 0;
  return Math.max(0, Math.min(...entries.map(([s, r]) => Math.floor((sizeQty[s] || 0) / r))));
};
